import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'

// CategoryNav
export const CategoryNav: React.FC = () => {
    const [showMenu, setShowMenu] = useState(false)
    const { t } = useTranslation()
    const toggleShowMenu = (event: React.MouseEvent) => {
        event.preventDefault();
        setShowMenu(!showMenu);
    }

    const handleItemClick = (e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (e) e.preventDefault();
        //etSelectedCategories(_.union(selectedCategories, categories.map(({ id }) => id)))
    }

    return (
        <nav className="secound-nav">
            <div className="placeholder">
                <span className="active nav-item" onClick={toggleShowMenu}>
                    <img src="/images/icons/small-icon-virtual-tours.png" alt="Virtual Tours" />
                    {t('Virtual Tours')}
                </span>
            </div>
            <ul style={{ display: showMenu ? 'block' : 'none' }}>
                {items.map((item, i) => (
                    <li key={i}>
                        <a href="/" onClick={handleItemClick} className="nav-item">
                            <img src={item.icon} alt={t(item.name)} />
                            {t(item.name)}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    )
}

const items = [
    {
        name: 'Virtual Tours',
        icon: '/images/icons/small-icon-virtual-tours.png'
    },
    {
        name: 'Hotels',
        icon: '/images/icons/small-icon-hotels.png'
    },
    {
        name: 'Villas',
        icon: '/images/icons/small-icon-villas.png'
    },
    // {
    //     name: 'Flights',
    //     icon: '/images/icons/small-icon-flights.png'
    // },
    {
        name: 'Activities',
        icon: '/images/icons/small-icon-activities.png'
    },
    {
        name: 'Restaurants',
        icon: '/images/icons/small-icon-restaurants.png'
    },
    {
        name: 'Coupons',
        icon: '/images/icons/small-icon-coupons.png'
    },
    // {
    //     name: 'Jobs',
    //     icon: '/images/icons/small-icon-jobs.png'
    // }
]